export default __webpack_public_path__ + "static/media/SVGClass.7fe4ff46.svg";